import axios from 'axios';
const config = {
    timeout: 30000
};
export class PssApi {
    constructor(pssHostUrl = '') {
        this.hostUrl = pssHostUrl;
        this.pssApi = axios.create({
            ...config,
            baseURL: pssHostUrl
        });
    }
}
//# sourceMappingURL=pss-api.service.js.map